import {useContext} from 'react';
import {User} from '@auth0/auth0-spa-js';
import Auth0Context from './context';
import {Auth0ContextInterface} from "@auth0/auth0-react/src/auth0-context.tsx";
import {useAuth0} from "@auth0/auth0-react";

/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */
const Index = <TUser extends User = User>(
    context = Auth0Context
): Auth0ContextInterface<TUser> =>
    useContext(context) as unknown as Auth0ContextInterface<TUser>;

export default window.location.href.toLowerCase().includes('mapp') ? Index : useAuth0;
